import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { z } from 'zod';
import { atomWithStaleRevalidate } from '../core/storage';
import { FocusResa } from '../core/focusResa';

export const userParser = z.object({
	ID: z.number(),
	display_name: z.string(),
	roles: z.array(z.string()),
	thumb: z.string(),
	link: z.string(),
});

export type User = z.infer<typeof userParser>;

export const mergeUsers = (prev: User[], next: User[]) => [
	...prev.filter((u) => !next.some((u2) => u2.ID == u.ID)),
	...next,
];

export const allUsersAtom = atomWithStaleRevalidate<User[]>(
	'focus-resa-users',
	async (lastUpdate: number) =>
		(!lastUpdate || Date.now() - lastUpdate > 10 * 60 * 1000) &&
		FocusResa.getInstance().getParticipants(),
	(_, next) => next,
	[],
);
export const userAtom = atomFamily((id: number) =>
	atom(
		(get) => get(allUsersAtom).find((u) => u.ID == id),
		(get, set, value: User) => {
			set(allUsersAtom, (users) => [
				...users.filter((u) => u.ID != value.ID),
				value,
			]);
		},
	),
);
